module.exports = __webpack_public_path__ + "static/beholder-2-76d68c7dc872caf78a9d34854cfadeb6.jpg";